import type { EventRead, EventSummary } from '@models/api';

export interface EventContextPayload {
  event_id: string | null;
  event_name: string | null;
  event_slug: string | null;
}

export const buildEventContextPayload = (
  event: EventRead | EventSummary | null | undefined,
): EventContextPayload => {
  if (!event) {
    return { event_id: null, event_name: null, event_slug: null };
  }
  return {
    event_id: event.id ?? null,
    event_name: event.name ?? null,
    event_slug: event.slug ?? null,
  };
};
